import { PROFILE_KEY } from "#api/user/profile.ts";
import { persistedStorageKey } from "./swrCache.ts";

/**
 * Set on `<html>` before first paint when this browser holds a persisted
 * profile — a visitor who is most likely still signed in.
 *
 * The prerendered HTML is always the signed-out header, and the restored
 * profile only reaches React right after hydration (see
 * `hideRestoredUntilHydrated`). Without a hint, a signed-in visitor watched the
 * Sign-in buttons paint and then get replaced by a wider user cluster, which
 * shoved the whole right side of the header ~300px to the left. With it, the
 * header keeps the signed-out slot invisible, so the cluster appears once, in
 * place.
 */
export const RESTORED_SESSION_ATTRIBUTE = "data-restored-session";

/** Inline, blocking `<head>` script: it must run before the body paints. */
export const restoredSessionScript = `try {
  if (localStorage.getItem(${JSON.stringify(persistedStorageKey(PROFILE_KEY))}) !== null) {
    document.documentElement.setAttribute("${RESTORED_SESSION_ATTRIBUTE}", "");
  }
} catch (e) {}`;

/**
 * The persisted profile turned out stale (the session is gone): drop the hint
 * so the signed-out controls it was hiding become visible.
 */
export function forgetRestoredSession(): void {
  document.documentElement.removeAttribute(RESTORED_SESSION_ATTRIBUTE);
}
